import { lazy, Suspense } from "react";
import Loader from "components/Loader";

const SubLayout = lazy(() => import("layout/SubLayout"));

// admin routes
const StaffsAdministration = lazy(() =>
  import("pages/admin/pages/staffs/administration/Administration")
);

const StaffsArchive = lazy(() =>
  import("pages/admin/pages/staffs/archive/Archive")
);

const ReferenceLessonType = lazy(() =>
  import("pages/admin/pages/reference/lessonType/LessonType")
);

const ReferenceSubjects = lazy(() =>
  import("pages/admin/pages/reference/subjects/Subjects")
);

const ReferencePositions = lazy(() =>
  import("pages/admin/pages/reference/positions/Positions")
);

const ReferenceNationality = lazy(() =>
  import("pages/admin/pages/reference/nationality/Nationality")
);

const ReferenceSpeciality = lazy(() =>
  import("pages/admin/pages/reference/speciality/Speciality")
);

const ReferenceEducationRank = lazy(() =>
  import("pages/admin/pages/reference/educationRank/EducationRank")
);

const ReferenceSubjectName = lazy(() =>
  import("pages/admin/pages/reference/subjectNames/SubjectNames")
);

const ReferenceCities = lazy(() =>
  import("pages/admin/pages/reference/cities/Cities")
);

const ReferenceEducationSpec = lazy(() =>
  import("pages/admin/pages/reference/educationSpeciality/EducationSpeciality")
);

const ReferenceCabinetType = lazy(() =>
  import("pages/admin/pages/reference/cabinetTypes/CabinetType")
);

const ReferenceCafedra = lazy(() =>
  import("pages/admin/pages/reference/cafedra/Cafedra")
);

const PriodsEducationYear = lazy(() =>
  import("pages/admin/pages/periods/educationYear/EducationYear")
);

const PeriodsSemester = lazy(() =>
  import("pages/admin/pages/periods/semesters/Semester")
);

const PeriodsShifts = lazy(() =>
  import("pages/admin/pages/periods/shifts/Shifts")
);

const GroupsCabinet = lazy(() =>
  import("pages/admin/pages/gruops/cabinets/Cabinet")
);

const GroupsSubject = lazy(() =>
  import("pages/admin/pages/gruops/subject/Subject")
);

const GroupsEditGroups = lazy(() =>
  import("pages/admin/pages/gruops/groups/Groups")
);

const GroupArchive = lazy(() =>
  import("pages/admin/pages/gruops/archive/Archive")
);

const SingleGroupLayout = lazy(() =>
  import("pages/admin/pages/gruops/groups/singleGroup/SingleGroupLayout")
);

const GroupStudents = lazy(() =>
  import("pages/admin/pages/gruops/groups/singleGroup/pages/students/Students")
);

const GroupSchedule = lazy(() =>
  import("pages/admin/pages/gruops/groups/singleGroup/pages/schedule/Schedule")
);

const GroupJournal = lazy(() =>
  import("pages/admin/pages/gruops/groups/singleGroup/pages/journal/Journal")
);

const GroupControl = lazy(() =>
  import("pages/admin/pages/gruops/groups/singleGroup/pages/control/Control")
);

const College = lazy(() => import("pages/admin/pages/college/College"));

const GroupTransition = lazy(() =>
  import("pages/admin/pages/gruops/transition/Transition")
);

// teacher routes

const ScheduleTeacherSchedule = lazy(() =>
  import("pages/teacher/pages/schedule/teacherSchedule/TeacherSchedule")
);

const CurrentGroupSchedule = lazy(() =>
  import(
    "pages/teacher/pages/schedule/currentGroupSchedule/CurrentGroupSchedule"
  )
);

const Journal = lazy(() => import("pages/teacher/pages/journal/Journal"));

const MyGroupStudentsAttendance = lazy(() =>
  import("pages/teacher/pages/myGroup/attendance/Attendance")
);

const MyGroupDiary = lazy(() =>
  import("pages/teacher/pages/myGroup/diary/Diary")
);

const MyGroupRating = lazy(() =>
  import("pages/teacher/pages/myGroup/rating/Rating")
);

const ParentActivity = lazy(() =>
  import("pages/teacher/pages/myGroup/parentActivity/ParentActivity")
);

// director routes

const StaffDoc = lazy(() =>
  import("pages/director/pages/staffs/staff/StaffDoc")
);
const StudentDoc = lazy(() =>
  import("pages/director/pages/groups/studentsInfo/StudentDoc")
);
const StaffsSubject = lazy(() =>
  import("pages/director/pages/staffs/subject/Subject")
);

const StaffSchedule = lazy(() =>
  import("pages/director/pages/staffs/schedule/Schedule")
);

const DirectorPeriodsSemester = lazy(() =>
  import("pages/director/pages/periods/semesters/Semester")
);

const DirectorPeriodsShifts = lazy(() =>
  import("pages/director/pages/periods/shifts/Shifts")
);

const DirectorGroupsCabinet = lazy(() =>
  import("pages/director/pages/groups/cabinets/Cabinet")
);

const DirectorGroupsEditGroups = lazy(() =>
  import("pages/director/pages/groups/groups/Groups")
);

const DirectorGroupStudents = lazy(() =>
  import(
    "pages/director/pages/groups/groups/singleGroup/pages/students/Students"
  )
);

const DirectorGroupSchedule = lazy(() =>
  import(
    "pages/director/pages/groups/groups/singleGroup/pages/schedule/Schedule"
  )
);

const DirectorGroupJournal = lazy(() =>
  import("pages/director/pages/groups/groups/singleGroup/pages/journal/Journal")
);

const DirectorStaffControl = lazy(() =>
  import("pages/director/pages/staffs/control/Control")
);

// parent routes

const Reference = lazy(() => import("pages/parent/pages/reference/Reference"));
const InformationGrade = lazy(() =>
  import("pages/parent/pages/information/grade/Grade")
);
const InformationSchedule = lazy(() =>
  import("pages/parent/pages/information/schedule/Schedule")
);
const InformationAttendance = lazy(() =>
  import("pages/parent/pages/information/attendance/Attendance")
);
const InformationSupervision = lazy(() =>
  import("pages/parent/pages/information/supervision/Supervision")
);

// reports
const CourseInfoReport = lazy(() =>
  import("pages/reports/pages/courseInfoReport/Report")
);

const CoursesAgesInfoReport = lazy(() =>
  import("pages/reports/pages/coursesAgesInfoReport/Report")
);

const CoursesInfoBySpecReport = lazy(() =>
  import("pages/reports/pages/coursesInfoBySpec/Report")
);

const CoursesInfoByRegionReport = lazy(() =>
  import("pages/reports/pages/coursesInfoByRegion/Report")
);

const CollegeGraduatesReport = lazy(() =>
  import("pages/reports/pages/collegeGraduatesReport/Report")
);

const CollegeDirectorsInfoReport = lazy(() =>
  import("pages/reports/pages/collegeDirectorsInfo/Report")
);

const CollegeCafedrasInfoReport = lazy(() =>
  import("pages/reports/pages/collegeCafedrasInfo/Report")
);

const AttendanceInSemesterReport = lazy(() =>
  import("pages/reports/pages/attendanceInSemester/Report")
);

const CoursesByLanguageReport = lazy(() =>
  import("pages/reports/pages/coursesByLanguage/Report")
);
const GraduateCoursesInfoByLanguageReport = lazy(() =>
  import("pages/reports/pages/graduateCoursesInfoByLanguage/Report")
);
const EducationQualityInSemestersReport = lazy(() =>
  import("pages/reports/pages/educationQualityInSemesters/Report")
);
const GraduateCoursesBySpecReport = lazy(() =>
  import("pages/reports/pages/graduateCoursesBySpec/Report")
);
const CoursesAttendenceInSemestersReport = lazy(() =>
  import("pages/reports/pages/coursesAttendenceInSemesters/Report")
);

export const userRoutes = {
  admin: [
    {
      path: "",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <StaffsAdministration />
            </Suspense>
          ),
        },
        {
          path: "archive",
          element: (
            <Suspense fallback={<Loader />}>
              <StaffsArchive />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "periods",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <PriodsEducationYear />
            </Suspense>
          ),
        },
        {
          path: "semesters",
          element: (
            <Suspense fallback={<Loader />}>
              <PeriodsSemester />
            </Suspense>
          ),
        },
        {
          path: "shifts",
          element: (
            <Suspense fallback={<Loader />}>
              <PeriodsShifts />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "groups",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <GroupsCabinet />
            </Suspense>
          ),
        },
        {
          path: "subject",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupsSubject />
            </Suspense>
          ),
        },
        {
          path: "editGroup",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupsEditGroups />
            </Suspense>
          ),
        },
        {
          path: "archive",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupArchive />
            </Suspense>
          ),
        },

        {
          path: "transition",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupTransition />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "groups/:groupId",
      element: (
        <Suspense fallback={<Loader />}>
          <SingleGroupLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <GroupStudents />
            </Suspense>
          ),
        },
        {
          path: "schedule",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupSchedule />
            </Suspense>
          ),
        },
        {
          path: "journal",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupJournal />
            </Suspense>
          ),
        },

        {
          path: "control",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupControl />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "aboutInfo",
      element: (
        <Suspense fallback={<Loader />}>
          <College />
        </Suspense>
      ),
    },

    {
      path: "reference",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceLessonType />
            </Suspense>
          ),
        },
        {
          path: "subjectNames",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceSubjectName />
            </Suspense>
          ),
        },
        {
          path: "subjects",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceSubjects />
            </Suspense>
          ),
        },
        {
          path: "positions",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferencePositions />
            </Suspense>
          ),
        },

        {
          path: "nationality",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceNationality />
            </Suspense>
          ),
        },

        {
          path: "speciality",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceSpeciality />
            </Suspense>
          ),
        },

        {
          path: "educationRank",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceEducationRank />
            </Suspense>
          ),
        },

        {
          path: "cities",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceCities />
            </Suspense>
          ),
        },

        {
          path: "educationSpeciality",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceEducationSpec />
            </Suspense>
          ),
        },

        {
          path: "cabinetType",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceCabinetType />
            </Suspense>
          ),
        },

        {
          path: "cafedra",
          element: (
            <Suspense fallback={<Loader />}>
              <ReferenceCafedra />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "statistic",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <CourseInfoReport />
            </Suspense>
          ),
        },
        {
          path: "coursesAgesInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesAgesInfoReport />
            </Suspense>
          ),
        },

        {
          path: "coursesInfoBySpec",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesInfoBySpecReport />
            </Suspense>
          ),
        },

        {
          path: "coursesInfoByRegion",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesInfoByRegionReport />
            </Suspense>
          ),
        },

        {
          path: "collegeGraduates",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeGraduatesReport />
            </Suspense>
          ),
        },

        {
          path: "directorsInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeDirectorsInfoReport />
            </Suspense>
          ),
        },

        {
          path: "cafedrasInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeCafedrasInfoReport />
            </Suspense>
          ),
        },
        {
          path: "attendanceInSemester",
          element: (
            <Suspense fallback={<Loader />}>
              <AttendanceInSemesterReport />
            </Suspense>
          ),
        },
        {
          path: "coursesByLanguage",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesByLanguageReport />
            </Suspense>
          ),
        },
        {
          path: "graduateCoursesInfoByLanguage",
          element: (
            <Suspense fallback={<Loader />}>
              <GraduateCoursesInfoByLanguageReport />
            </Suspense>
          ),
        },
        {
          path: "educationQualityInSemesters",
          element: (
            <Suspense fallback={<Loader />}>
              <EducationQualityInSemestersReport />
            </Suspense>
          ),
        },
        {
          path: "graduateCoursesBySpecReport",
          element: (
            <Suspense fallback={<Loader />}>
              <GraduateCoursesBySpecReport />
            </Suspense>
          ),
        },
        {
          path: "coursesAttendenceInSemesters",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesAttendenceInSemestersReport />
            </Suspense>
          ),
        },
      ],
    },
  ],
  teacher: [
    {
      path: "",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <ScheduleTeacherSchedule />
            </Suspense>
          ),
        },
        {
          path: "myGroupSchedule/:groupId",
          element: (
            <Suspense fallback={<Loader />}>
              <CurrentGroupSchedule />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "journal",
      element: (
        <Suspense fallback={<Loader />}>
          <Journal />
        </Suspense>
      ),
    },
  ],

  curator: [
    {
      path: "",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <ScheduleTeacherSchedule />
            </Suspense>
          ),
        },
        {
          path: "myGroupSchedule/:groupId",
          element: (
            <Suspense fallback={<Loader />}>
              <CurrentGroupSchedule />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "journal",
      element: (
        <Suspense fallback={<Loader />}>
          <Journal />
        </Suspense>
      ),
    },

    {
      path: "myGroup",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <MyGroupDiary isHeadCurse={false} />
            </Suspense>
          ),
        },
        {
          path: "attendance",
          element: (
            <Suspense fallback={<Loader />}>
              <MyGroupStudentsAttendance />
            </Suspense>
          ),
        },
        {
          path: "parentActivity",
          element: (
            <Suspense fallback={<Loader />}>
              <ParentActivity />
            </Suspense>
          ),
        },

        {
          path: "rating",
          element: (
            <Suspense fallback={<Loader />}>
              <MyGroupRating />
            </Suspense>
          ),
        },
      ],
    },
  ],
  parent: [
    {
      path: "",
      element: (
        <Suspense fallback={<Loader />}>
          <Reference />
        </Suspense>
      ),
    },
    {
      path: "child",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <InformationGrade />
            </Suspense>
          ),
        },
        {
          path: "/child/schedule",
          element: (
            <Suspense fallback={<Loader />}>
              <InformationSchedule />
            </Suspense>
          ),
        },
        {
          path: "/child/attendance",
          element: (
            <Suspense fallback={<Loader />}>
              <InformationAttendance />
            </Suspense>
          ),
        },
        {
          path: "/child/control",
          element: (
            <Suspense fallback={<Loader />}>
              <InformationSupervision />
            </Suspense>
          ),
        },
      ],
    },
  ],

  director: [
    {
      path: "",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorStaffControl />
            </Suspense>
          ),
        },
        {
          path: "schedule",
          element: (
            <Suspense fallback={<Loader />}>
              <StaffSchedule />
            </Suspense>
          ),
        },

        {
          path: "subject",
          element: (
            <Suspense fallback={<Loader />}>
              <StaffsSubject />
            </Suspense>
          ),
        },

        {
          path: "doc",
          element: (
            <Suspense fallback={<Loader />}>
              <StaffDoc />
            </Suspense>
          ),
        },

        {
          path: "archive",
          element: (
            <Suspense fallback={<Loader />}>
              <p>Бойгонӣ</p>
            </Suspense>
          ),
        },
        ],
    },

    {
      path: "periods",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorPeriodsSemester />
            </Suspense>
          ),
        },
        {
          path: "shifts",
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorPeriodsShifts />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "groups",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupsCabinet />
            </Suspense>
          ),
        },
        {
          path: "editGroup",
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupsEditGroups />
            </Suspense>
          ),
        },

        {
          path: "students",
          element: (
            <Suspense fallback={<Loader />}>
              <StudentDoc />
            </Suspense>
          ),
        },

        {
          path: "archive",
          element: (
            <Suspense fallback={<Loader />}>
              <p>Бойгонӣ</p>
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "groups/:groupId",
      element: (
        <Suspense fallback={<Loader />}>
          <SingleGroupLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupStudents />
            </Suspense>
          ),
        },
        {
          path: "schedule",
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupSchedule />
            </Suspense>
          ),
        },
        {
          path: "journal",
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupJournal />
            </Suspense>
          ),
        },
        {
          path: "control",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupControl />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "statistic",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <CourseInfoReport />
            </Suspense>
          ),
        },
        {
          path: "coursesAgesInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesAgesInfoReport />
            </Suspense>
          ),
        },
        {
          path: "coursesInfoBySpec",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesInfoBySpecReport />
            </Suspense>
          ),
        },

        {
          path: "coursesInfoByRegion",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesInfoByRegionReport />
            </Suspense>
          ),
        },
        {
          path: "collegeGraduates",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeGraduatesReport />
            </Suspense>
          ),
        },
        {
          path: "directorsInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeDirectorsInfoReport />
            </Suspense>
          ),
        },
        {
          path: "cafedrasInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeCafedrasInfoReport />
            </Suspense>
          ),
        },
        {
          path: "attendanceInSemester",
          element: (
            <Suspense fallback={<Loader />}>
              <AttendanceInSemesterReport />
            </Suspense>
          ),
        },
        {
          path: "coursesByLanguage",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesByLanguageReport />
            </Suspense>
          ),
        },
         {
          path: "graduateCoursesInfoByLanguage",
          element: (
            <Suspense fallback={<Loader />}>
              <GraduateCoursesInfoByLanguageReport />
            </Suspense>
          ),
        },
        {
          path: "educationQualityInSemesters",
          element: (
            <Suspense fallback={<Loader />}>
              <EducationQualityInSemestersReport />
            </Suspense>
          ),
        },
        {
          path: "graduateCoursesBySpecReport",
          element: (
            <Suspense fallback={<Loader />}>
              <GraduateCoursesBySpecReport />
            </Suspense>
          ),
        },
        {
          path: "coursesAttendenceInSemesters",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesAttendenceInSemestersReport />
            </Suspense>
          ),
        },
      ],
    },
  ],

  headTeacher: [
    {
      path: "",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorStaffControl />
            </Suspense>
          ),
        },
        {
          path: "schedule",
          element: (
            <Suspense fallback={<Loader />}>
              <StaffSchedule />
            </Suspense>
          ),
        },

        {
          path: "subject",
          element: (
            <Suspense fallback={<Loader />}>
              <StaffsSubject />
            </Suspense>
          ),
        },

        {
          path: "doc",
          element: (
            <Suspense fallback={<Loader />}>
              <StaffDoc />
            </Suspense>
          ),
        },

        {
          path: "archive",
          element: (
            <Suspense fallback={<Loader />}>
              <p>Бойгонӣ</p>
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "periods",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorPeriodsSemester />
            </Suspense>
          ),
        },
        {
          path: "shifts",
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorPeriodsShifts />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "groups",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupsCabinet />
            </Suspense>
          ),
        },
        {
          path: "editGroup",
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupsEditGroups />
            </Suspense>
          ),
        },

        {
          path: "students",
          element: (
            <Suspense fallback={<Loader />}>
              <StudentDoc />
            </Suspense>
          ),
        },

        {
          path: "archive",
          element: (
            <Suspense fallback={<Loader />}>
              <p>Бойгонӣ</p>
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "groups/:groupId",
      element: (
        <Suspense fallback={<Loader />}>
          <SingleGroupLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupStudents />
            </Suspense>
          ),
        },
        {
          path: "schedule",
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupSchedule />
            </Suspense>
          ),
        },
        {
          path: "journal",
          element: (
            <Suspense fallback={<Loader />}>
              <DirectorGroupJournal />
            </Suspense>
          ),
        },
        {
          path: "control",
          element: (
            <Suspense fallback={<Loader />}>
              <GroupControl />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "statistic",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <CourseInfoReport />
            </Suspense>
          ),
        },
        {
          path: "coursesAgesInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesAgesInfoReport />
            </Suspense>
          ),
        },
        {
          path: "coursesInfoBySpec",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesInfoBySpecReport />
            </Suspense>
          ),
        },

        {
          path: "coursesInfoByRegion",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesInfoByRegionReport />
            </Suspense>
          ),
        },
        {
          path: "collegeGraduates",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeGraduatesReport />
            </Suspense>
          ),
        },

        {
          path: "directorsInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeDirectorsInfoReport />
            </Suspense>
          ),
        },
        {
          path: "cafedrasInfo",
          element: (
            <Suspense fallback={<Loader />}>
              <CollegeCafedrasInfoReport />
            </Suspense>
          ),
        },
        {
          path: "attendanceInSemester",
          element: (
            <Suspense fallback={<Loader />}>
              <AttendanceInSemesterReport />
            </Suspense>
          ),
        },
        {
          path: "coursesByLanguage",
          element: (
            <Suspense fallback={<Loader />}>
              <CoursesByLanguageReport />
            </Suspense>
          ),
        },
      ],
    },
  ],
  groupHead: [
    {
      path: "",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        // {
        //   index: true,
        //   element: (
        //     <Suspense fallback={<Loader />}>
        //       <ScheduleTeacherSchedule />
        //     </Suspense>
        //   ),
        // },
        {
          path: "myGroupSchedule/:groupId",
          element: (
            <Suspense fallback={<Loader />}>
              <CurrentGroupSchedule />
            </Suspense>
          ),
        },
      ],
    },

    {
      path: "journal",
      element: (
        <Suspense fallback={<Loader />}>
          <Journal isHeadCourse />
        </Suspense>
      ),
    },

    {
      path: "myGroup",
      element: (
        <Suspense fallback={<Loader />}>
          <SubLayout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <MyGroupDiary isHeadCurse />
            </Suspense>
          ),
        },
        {
          path: "attendance",
          element: (
            <Suspense fallback={<Loader />}>
              <MyGroupStudentsAttendance isHeadCourse />
            </Suspense>
          ),
        },
        {
          path: "parentActivity",
          element: (
            <Suspense fallback={<Loader />}>
              <ParentActivity />
            </Suspense>
          ),
        },

        {
          path: "rating",
          element: (
            <Suspense fallback={<Loader />}>
              <MyGroupRating />
            </Suspense>
          ),
        },
      ],
    },
  ],
};
